import type { AppProps } from 'next/app';
import dynamic from 'next/dynamic';
import ResizeObserver from 'resize-observer-polyfill';
// Hooks
import {
  useScrollToTopOnLoad,
  useFacebookPixel,
  useGoogleAnalytics,
  useTiktokAnalytics,
} from 'hooks';
import { useIosNoInputZoom } from 'hooks/useIosNoInputZoom';
// Context
import { AppProvider } from 'context/AppContext';
import { OnboardingProvider } from 'context/OnboardingContext';
// Layouts
import ExternalScripts from 'layouts/ExternalScripts/ExternalScripts';
// Components
import CookieConsent from 'components/common3/CookieConsent/CookieConsent';

// TODO: remove line below after removing old styles
import 'styles/globals.scss';
import 'styles3/globals.scss';
import 'stream-chat-react/dist/css/v2/index.css';

const DynamicToast = dynamic(() => import('components/common/Toast/Toast'), {
  ssr: false,
});

// polyfill to support a react-virtuoso package in old browsers
if (process.browser && !window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}

const App = ({ Component, pageProps }: AppProps): JSX.Element => {
  useScrollToTopOnLoad();
  useFacebookPixel();
  useGoogleAnalytics();
  useTiktokAnalytics();
  useIosNoInputZoom();

  return (
    <>
      <ExternalScripts />

      <AppProvider>
        <OnboardingProvider>
          <Component {...pageProps} />
        </OnboardingProvider>
      </AppProvider>
      <DynamicToast />
      <CookieConsent />
    </>
  );
};

export default App;
